import Vue from 'vue' // VUE
import App from './App.vue' // 项目入口
import router from './router' // 路由
import store from './store' // vue 状态库
import ViewUI, { Row } from 'view-design'
import 'view-design/dist/styles/iview.css'
import './icons'
import './router/filter/index'
import HighchartsVue from 'highcharts-vue' // highcharts 组件库
import { getSystemSelection } from './api/global/globalApi' // 全局下拉框接口
import { checkBtnPermission, formatDate, notify, formatDateYMD, jsToFormData, getCommandStatus, formatTimeParams } from './utils/util.js' // 全局工具类
import BaiduMap from '@/components/vue-baidu-map'
import * as filters from './filters' // 全局过滤方法
import _ from 'lodash'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
const mxVideo = require('./utils/mxvideo.js')
import plugins from './plugins' // plugins

import { Table, Pagination, Checkbox, Layout, Icon, Menu, Tag, ConfigProvider, Tabs, Steps, Radio } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Table);
Vue.use(Layout);
Vue.use(Icon);
Vue.use(Menu);
Vue.use(Tag);
Vue.use(Tabs);
Vue.use(Steps);
Vue.use(ConfigProvider);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(plugins)

Vue.prototype.$getSystemSelection = getSystemSelection
Vue.prototype.checkBtnPermission = checkBtnPermission
Vue.prototype.formatDate = formatDate
Vue.prototype.getCommandStatus = getCommandStatus
Vue.prototype.jsToFormData = jsToFormData
Vue.prototype.mxVideo = mxVideo
Vue.prototype.$formatDateYMD = formatDateYMD
Vue.prototype.formatTimeParams = formatTimeParams
Vue.prototype.Notify = notify
Vue.prototype._ = _
Vue.prototype.loading = ViewUI.LoadingBar
Vue.use(ElementUI)
Vue.use(router)
Vue.use(ViewUI)
Vue.use(HighchartsVue)
// 全局过滤方法 注册
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.use(BaiduMap, {
    ak: 'JN7QHKiqbaPcJnWeYD45gC25mCd3Qcag'
})

// runtime（运行模式）
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')